// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailI":"I_d2xDetailI__Aiib9"};